import envConfig from "@/config/envConfig";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { App, Form, Upload } from "antd";
import PropTypes from "prop-types";

const CustomUpload = ({ form, formItemsProps, uploadProps = {}, maxSizeMB = 5 }) => {
  const maxCount = uploadProps.maxCount || 1;
  const multiple = uploadProps.multiple || maxCount > 1;
  const { notification } = App.useApp();

  const watchUpload = Form.useWatch(formItemsProps.name, form);
  const loading = false;

  const uploadedFiles = Array.isArray(watchUpload) ? watchUpload : watchUpload ? [watchUpload] : [];

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return multiple ? e?.map((file) => file.response?.data || file) : e[0]?.response?.data || e[0];
    }
    return multiple
      ? e?.fileList?.map((file) => file.response?.data || file)
      : e.fileList[0]?.response?.data || e.fileList[0];
  };

  const handleBeforeUpload = (file) => {
    const accept = uploadProps.accept || "";
    const lowerAccept = accept.toLowerCase();

    // Type check
    if (lowerAccept.includes("image/*")) {
      if (!file.type.startsWith("image/")) {
        notification.error({
          message: "Only image files are allowed!",
          duration: 2,
          showProgress: true,
        });
        return Upload.LIST_IGNORE;
      }
    } else if (lowerAccept.includes(".pdf")) {
      if (file.type !== "application/pdf") {
        notification.error({
          message: "Only PDF files are allowed!",
          duration: 2,
          showProgress: true,
        });
        return Upload.LIST_IGNORE;
      }
    } else if (lowerAccept) {
      // Generic extension check (for future custom accept like ".docx")
      const allowedExts = lowerAccept.split(",").map((x) => x.trim().replace(".", ""));
      const fileExt = file.name.split(".").pop()?.toLowerCase();
      if (fileExt && !allowedExts.includes(fileExt)) {
        notification.error({
          message: `Invalid file type. Allowed: ${allowedExts.join(", ")}`,
          duration: 2,
          showProgress: true,
        });
        return Upload.LIST_IGNORE;
      }
    }

    // Size check
    if (file.size / 1024 / 1024 > maxSizeMB) {
      notification.error({
        message: `File size must be smaller than ${maxSizeMB} MB!`,
        duration: 2,
        showProgress: true,
      });
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  return (
    <Form.Item
      {...formItemsProps}
      getValueFromEvent={normFile}
      getValueProps={(value) => ({ value: Array.isArray(value) ? value : [value] })}
      extra={
        <div>
          {uploadedFiles.length > 0 &&
            uploadedFiles.map((f, i) => (
              <div key={i}>
                File: .../{f.uid}.{f.name?.split(".").pop()}
              </div>
            ))}
          {formItemsProps?.extra || ""}
        </div>
      }
    >
      <Upload
        action={`${envConfig.API_URL}/file${"/upload"}`}
        listType="picture-card"
        // isImageUrl={(file: any) => file.mimetype?.startsWith("image/")}
        fileList={uploadedFiles}
        beforeUpload={handleBeforeUpload}
        // iconRender={(file) => <img src={mimePreviewMap[file.mimetype] || mimePreviewMap.default} alt="preview" />}
        name={"file"}
        {...uploadProps}
      >
        {uploadedFiles?.length >= maxCount ? null : uploadButton}
      </Upload>
    </Form.Item>
  );
};

export default CustomUpload;

CustomUpload.propTypes = {
  form: PropTypes.any,
  formItemsProps: PropTypes.object,
  uploadProps: PropTypes.object,
  maxSizeMB: PropTypes.number,
};
